import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=c4907484&"
import script from "./TreeSelect.vue?vue&type=script&lang=js&"
export * from "./TreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports